<template>
  <div>
    <div>
      <div ref="card"></div>
      <p id="card-error" role="alert"></p>
      <v-btn
       :loading="paymentStarted" 
       :disabled="disablePayment || disablePaymentCommon || isDisabled" @click="proceedPayment">CONFIRM PAYMENT</v-btn>
    </div>
  </div>
</template>

<script>
import { loadStripe } from '@stripe/stripe-js'
import CebelcaService from '../../services/CebelcaService'
import { mapState } from 'vuex';
import publicIpAddress from 'public-ip'

export default {
  data() {
    return {
      stripe: null,
      elements: null,
      card: null,
      isDisabled: true,
      clientSecret: '',
      paymentStarted: false,
      paymentResponse: {}
    }
  },
  async mounted() {
    // this.getPaymentIntent()
    let self = this
    this.stripe = await loadStripe(
      await this.$store.dispatch('getKeys', this.productDetails.product_Id)
    )
    this.elements = this.stripe.elements()
    this.card = this.elements.create('card', {
      hidePostalCode: true
    })
    this.card.mount(this.$refs.card)
    this.card.on('change', function (event) {
      document.querySelector('#card-error').textContent = event.error ? event.error.message : ''
        if(event.complete) {
          self.isDisabled = false
        } else {
          self.isDisabled = true
        }
    })
    //    const ibanOptions = {
    //   supportedCountries: ['SEPA'],
    // };
    // const iban = this.elements.create('iban', ibanOptions);

    // // Mount the IBAN Element on the page.
    // iban.mount(this.$refs.ibanElements);
    // const idealBank = this.elements.create('idealBank');

    // // Mount the iDEAL Bank Element on the page.
    // idealBank.mount(this.$refs.idealBankElement);
    // const becsBank = this.elements.create('auBankAccount');

    // const paymentRequest = this.stripe.paymentRequest({
    //   country: 'GR',
    //   currency: 'eur',
    //   total: {
    //     label: 'Total',
    //     amount: 112,
    //   }
    // });

    // // Mount the BECS element on the page.
    // becsBank.mount(this.$refs.BecsBankAccount);
    // const paymentRequestButton = this.elements.create('paymentRequestButton', {
    //   paymentRequest,
    // });

    // // Check if the Payment Request is available (or Apple Pay on the Web).
    // const paymentRequestSupport = await paymentRequest.canMakePayment();
    // if (paymentRequestSupport) {
    //   // Display the Pay button by mounting the Element in the DOM.
    //   paymentRequestButton.mount(this.$refs.PaymentRequestButton);
    //   // Replace the instruction.
    //   document.querySelector('.instruction span').innerText = 'Or enter';
    //   // Show the payment request section.
    //   document.getElementById('payment-request').classList.add('visible');
    // }
  },
  methods: {
    async getPaymentIntent() {
      const paymentIntent = await this.$store.dispatch('getPaymentIntent', { productId: this.productDetails.product_Id, body: this.generateBody()})
      this.clientSecret = paymentIntent.client_secret
    },
    proceedPayment() {
      let self = this
      self.paymentStarted = true;
      this.stripe.createPaymentMethod({
        type: 'card',
        card: this.card
      })
      .then(async function(result) {
        if (result.error) {
          // Show error to your customer
          console.log(result.error.message);
        } else {
          const invoice = await self.upsertOrder(result.paymentMethod.id)
          self.paymentStarted = false
          self.paymentResponse = result
          self.paymentResponse.last4 = result.paymentMethod.card.last4
          self.paymentResponse.amount = invoice.amount
          self.paymentResponse.currency = 'EUR'
          self.$emit('success-response', self.paymentResponse)
        }
      });
    },
    generateBody() {
      const body = {}
      body.amount = this.cartTotalPrice * 100
      body.currency = 'eur'
      return body
    },
    updateStock() {
      this.$store.dispatch('updateStock', this.cartItems)
    },
    async upsertOrder(paymentMethodId) {
      const timeResponse = await this.getTime()
      const orderBody = { cart_id: this.cartItems[0].cart_id,  delivery_type: this.flow === 'shippable' ? 'shipping' : 'self-service', status: this.flow === 'shippable' ? 'pending' : 'delivered' }
      if (this.shippingRate) {
        orderBody.estimated_delivery_days = this.shippingRate.estimated_delivery_days
        orderBody.estimated_delivery_date = this.shippingRate.estimated_delivery_date
        orderBody.estimated_pickup_date = this.shippingRate.estimated_pickup_date
        orderBody.platform = this.shippingRate.platform
        orderBody.service_type = this.shippingRate.service_type
      }
      const orderData = await this.$store.dispatch('order/upsertOrder', orderBody)
      const invoiceBody = { order_id: orderData.insertId, type: 'stripe_intent', cart_items: this.cartItems, paymentMethodId: paymentMethodId, datetime: timeResponse }
      if (this.shippingRate) invoiceBody.shipping_cost = this.shippingRate.shipping_cost
      const invoiceData = await this.$store.dispatch('addInvoice', invoiceBody)
      if (invoiceData) {
        this.updateStock()
        const date = new Date()
        const user = JSON.parse(localStorage.getItem('user'))
        CebelcaService.fiscalizeInvoice({
          email: user.email,
          invoice_id: invoiceData.invoice_id,
          invoice_date: `${date.getDate()}.${date.getMonth()+1}.${date.getFullYear()}`,
          cart_items: this.cartItems,
          shipping_cost: (this.shippingRate && this.shippingRate.shipping_cost) ? this.shippingRate.shipping_cost : undefined
        })
      }
      return invoiceData
    },
    async getTime() {
      const publicIp = await publicIpAddress.v4()
      return new Promise((resolve, reject) => {
        this.$store.dispatch('timeapi', publicIp)
        .then((response) => {
          const datetime = response.data
          return resolve(datetime)
        }).catch(error => {
          return reject(error)
        })
      })
    },
    async getPaymentMethod(paymentResponse) {
      const paymentMethod = await this.$store.dispatch('getPaymentMethod', { paymentMethodId: paymentResponse.paymentIntent.payment_method, cartId: this.cartItems[0].cart_id})
      return paymentMethod.last4
    }
  },
  props: {
    productDetails: {},
    cartTotalPrice: {
      type: Number,
      default: 0
    },
    cartItems: {
      type: Array
    },
    disablePayment: Boolean,
    disablePaymentCommon: Boolean,
    flow: String,
    shippingRate: Object
  },
  computed: mapState(['order']),
}
</script>

<style lang="scss" scoped>
/**
 * The CSS shown here will not be introduced in the Quickstart guide, but shows
 * how you can use CSS to style your Element's container.
 */
.StripeElement {
  box-sizing: border-box;

  height: 40px;

  padding: 10px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
  margin-bottom: 10px;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

.about-img2 {
  display: inline-block;
  width: 100%;
  margin-top: -20px;
  max-width: 250px;
  text-align: center;
  vertical-align: top;
}

.info-btn
{
  color: #fff;
  background: var(--primary);
  text-decoration: none !important;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 2px;
  padding: 10px 20px;
  border-radius: 5px;
  transition: 0.3s;
  transition-property: background;
}

.info-btn:hover{
  background: #0C4F60;
}

// media queries for common device breakpoints 

//Galaxy Fold //
@media only screen and (min-device-width : 270px) and (max-device-width : 280px) {
.about-img2 {
  margin-top: -10px;
  max-width: 200px;
}
}
//
@media only screen and (min-device-width : 281px) and (max-device-width : 320px) {
.about-img2 {
  margin-top: -10px;
  max-width: 200px;
}
}
//iPhone 5 //
@media only screen and (min-device-width : 321px) and (max-device-width : 359px) and (orientation : portrait)  {
.about-img2 {
  margin-top: -15px;
  max-width: 230px;
}
}
//Galaxy S5/S8/Moto S4 //
@media only screen and (min-device-width : 360px) and (max-device-width : 374px) and (orientation : portrait)  {
.about-img2 {
  margin-top: -20px;
  max-width: 250px;
}
}
//iPhone 6/7/8/X/11Pro/12 Mini //
@media only screen and (min-device-width : 375px) and (max-device-width : 389px) and (orientation : portrait)  {
.about-img2 {
  margin-top: -20px;
  max-width: 250px;
}
}
//iPhone 12/12Pro //
@media only screen and (min-device-width : 390px) and (max-device-width : 413px) and (orientation : portrait)  {
.about-img2 {
  margin-top: -23px;
  max-width: 270px;
}
}
//iPhone 6/7/8 Plus/11 //
@media only screen and (min-device-width : 414px) and (max-device-width : 440px) and (orientation : portrait)  {
.about-img2 {
  margin-top: -25px;
  max-width: 290px;
}
}
</style>
